import { useIntl, FormattedMessage } from 'react-intl';
import { useMemo } from 'react';
import { cx } from '@emotion/css';

import { useStyles } from './reason-list.styles';
import check from '../../../../../../assets/images/cv/check-in-eye.svg';
import eye from '../../../../../../assets/images/cv/eye-in-magnifier.svg';
import drop from '../../../../../../assets/images/cv/drop-over-the-bowl.svg';
import { ReasonItem } from './reason.models';
import { ListUnordered } from '../../../../../common';
import { ListItem } from '../../../../../common/list-unordered';

const Item = ({ icon, iconText, item }: Omit<ReasonItem, 'id'>): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <span className={classes.icon}>
        {icon && <img src={icon} alt="" />}
        {iconText && <span className={cx(classes.iconText, classes.icon)}>{iconText}</span>}
      </span>
      {item}
    </>
  );
};

export const ReasonList = ({ points }: { points: number }): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();

  const reasons = useMemo((): ListItem[] => {
    return [
      {
        id: 'controlVisit.modal.reason-1',
        item: <Item item={<FormattedMessage id="controlVisit.modal.reason-1" />} icon={check} />,
      },
      {
        id: 'controlVisit.modal.reason-2',
        item: <Item item={intl.formatMessage(
          { id: 'controlVisit.modal.reason-2' },
          { noBreak: <>&nbsp;</> },
        )} icon={eye} />,
      },
      {
        id: 'controlVisit.modal.reason-3',
        item: <Item item={<FormattedMessage id="controlVisit.modal.reason-3" />} icon={drop} />,
      },
      {
        id: 'controlVisit.modal.reason-4',
        item: <Item item={<FormattedMessage id="controlVisit.modal.reason-4" values={{ points }} />} iconText={points} />,
      },
    ];
  }, [intl, points]);

  return (
    <ListUnordered listStyles={classes.list} items={reasons} listGap="gap-16" itemStyles={classes.item} testId="reason-list" />
  );
};
